export default "__VITE_ASSET__10f1c01d__"